import { FormEvent, useState } from 'react';
import { useAuthContext } from 'src/contexts/AuthContext';
import { useModal } from '../context/ModalContext';

export function LoginPanel() {
  const { signIn } = useAuthContext();
  const { open } = useModal();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setError(null);
    setIsSubmitting(true);
    try {
      // On success the auth state changes and the whole marketing tree
      // unmounts, so there is no modal to close manually.
      await signIn(email.trim(), password);
    } catch (err) {
      setError(
        err instanceof Error ? err.message : 'Unable to sign in. Try again.',
      );
      setIsSubmitting(false);
    }
  }

  return (
    <form className="contact-form" onSubmit={handleSubmit}>
      <div className="row gx-gs gy-5">
        <div className="col-12">
          <div className="form-group">
            <label className="form-label" htmlFor="login-email">
              Email
            </label>
            <div className="form-control-wrap">
              <input
                type="email"
                id="login-email"
                name="email"
                autoComplete="username"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-control form-control-xl"
                placeholder="Enter your email"
              />
            </div>
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <label className="form-label" htmlFor="login-password">
              Password
            </label>
            <div className="form-control-wrap">
              <input
                type="password"
                id="login-password"
                name="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-control form-control-xl"
                placeholder="Enter your password"
              />
            </div>
          </div>
        </div>
        <div className="col-12">
          <div className="d-flex justify-content-between gap-3">
            <button
              type="button"
              onClick={() => open('forgot')}
              className="link link-primary link-hover-title btn btn-link p-0">
              Forgot Password?
            </button>
          </div>
        </div>
        {error && (
          <div className="col-12">
            <p className="text-danger mb-0" role="alert">
              {error}
            </p>
          </div>
        )}
        <div className="col-12">
          <button
            type="submit"
            disabled={isSubmitting}
            className="btn btn-outline-light btn-lg btn-block opacity-80">
            {isSubmitting ? 'Signing in…' : 'Login'}
          </button>
        </div>
      </div>
    </form>
  );
}
